var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg mail",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4,5.8A1.54,1.54,0,0,0,2.9,7.3V24.7a1.54,1.54,0,0,0,1.5,1.5H27.6a1.54,1.54,0,0,0,1.5-1.5V7.3a1.54,1.54,0,0,0-1.5-1.5ZM0,7.3A4.44,4.44,0,0,1,4.4,2.9H27.6A4.44,4.44,0,0,1,32,7.3V24.7a4.44,4.44,0,0,1-4.4,4.4H4.4A4.44,4.44,0,0,1,0,24.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.3,6.5a1.47,1.47,0,0,1,2-.4L16,15.7,29.7,6.1a1.35,1.35,0,0,1,2,.4,1.35,1.35,0,0,1-.4,2L16.8,18.6a1.72,1.72,0,0,1-1.7,0L.6,8.5A1.44,1.44,0,0,1,.3,6.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5dc10fc742b7229f11f5b732d21f668d.svg";
export { ForwardRef as ReactComponent };